module.exports = "/_next/static/images/vintage-3-3a99e81a880f8132d645866b1423fa5e.png";